import api from './api'

export default {
  /**
   * Listar todos os usuários
   */
  async listUsers() {
    return await api.get('/auth/users')
  },

  /**
   * Criar novo usuário
   * @param {Object} userData - Dados do usuário
   * @param {string} userData.username - Nome de usuário
   * @param {string} userData.password - Senha (será convertida para hash no backend)
   * @param {string} userData.email - Email
   * @param {string} userData.role - Role (admin ou user)
   * @param {boolean} userData.isActive - Status ativo/inativo
   */
  async createUser(userData) {
    return await api.post('/auth/users', userData)
  },

  /**
   * Atualizar usuário
   * @param {number} userId - ID do usuário
   * @param {Object} userData - Dados do usuário para atualizar
   */
  async updateUser(userId, userData) {
    return await api.put(`/auth/users/${userId}`, userData)
  },

  /**
   * Deletar usuário (se existir endpoint no backend)
   * @param {number} userId - ID do usuário
   */
  async deleteUser(userId) {
    return await api.delete(`/auth/users/${userId}`)
  }
}
